import React from 'react'
import FormatNumber from '@i18n/formatNumber/Component'
import {useTranslation} from 'next-i18next'

import promotionTypes from '../../../utils/promotionTypes'

import styles from '../styles.module.css'

const renderPriceWithDiscounts = props => {
  if (props.hidePrice) return null
  const {finalPrice, basePrice} = props.product.availabilityAt
  return (
    <div>
      <div className={styles.pastPrice}>
        <FormatNumber value={basePrice} />
      </div>
      <div className={styles.price}>
        <FormatNumber value={finalPrice} />
      </div>
    </div>
  )
}

const renderPriceWithPromotion = ({props, t}) => {
  const {availabilityAt, promotions} = props.product
  const {finalPrice} = availabilityAt
  return (
    <div>
      <div className={styles.pricePromotion}>
        <div className={styles.price}>
          <FormatNumber value={finalPrice} />
        </div>
        <div className={styles.promotion}>{promotionTypes[promotions[0].promotionType](t)}</div>
      </div>
      {/* Uso  para futuras promociones con monto o % de descuento del precio
      <div className={styles.pastPrice}>
        <FormatNumber value={basePrice} />
      </div> */}
    </div>
  )
}

export default function Price(props) {
  const {t} = useTranslation('website')
  const {availabilityAt, promotions} = props.product
  if (!availabilityAt || props.hidePrice || !availabilityAt.finalPrice) return null
  const {hasDiscount, finalPrice, available, notAvailableMessage} = availabilityAt
  if (!available) return <div className={styles.notAvailable}>{notAvailableMessage}</div>
  if (hasDiscount) return renderPriceWithDiscounts(props)
  if (promotions && promotions.length) return renderPriceWithPromotion({props, t})
  return (
    <div className={styles.price}>
      <FormatNumber value={finalPrice} />
    </div>
  )
}
